import React from 'react';
import { StyledButton, Href } from './style';

const Button = ({ text, onClick, style, link, href }) => {
    const LinkButton = (
        <Href href={href}>
            <StyledButton
                onClick={onClick}
                {...style}
            >
                {text}
            </StyledButton>
        </Href>
    );

    const DefaultButton = (
        <StyledButton
            onClick={onClick}
            {...style}
        >
            {text}
        </StyledButton>
    );

    const result = link ? LinkButton : DefaultButton;

    return (
        result
    );
};

export default Button;
